import { cn } from '@/lib/utils'

interface LoadingStateProps {
  /** Loading message to display below the spinner */
  message?: string
  /** Whether to use full screen height */
  fullScreen?: boolean
  /** Additional CSS classes for the container */
  className?: string
}

/**
 * LoadingState - A reusable loading indicator with spinner and optional message
 *
 * Used across the dashboard for consistent loading UX matching the NavigationProvider pattern.
 *
 * @example
 * // Basic usage
 * <LoadingState message="Loading organizations..." />
 *
 * @example
 * // Full screen loading
 * <LoadingState message="Loading provider costs..." fullScreen />
 *
 * @example
 * // Custom container styling
 * <LoadingState message="Loading..." className="py-12" />
 */
export function LoadingState({
  message = 'Loading...',
  fullScreen = false,
  className,
}: LoadingStateProps) {
  return (
    <div
      className={cn(
        'flex items-center justify-center',
        fullScreen ? 'h-screen' : 'py-12',
        className
      )}
    >
      <div className="text-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mx-auto mb-4"></div>
        <p className="text-sm text-gray-600 dark:text-zinc-400">{message}</p>
      </div>
    </div>
  )
}
